import { useEffect, useState } from "react"
import styled from "styled-components"
import { usePolicy } from "../../hooks/usePolicy"
import Header from "./Header"
import { toast } from "react-toastify"

const Privacy = () => {
  const { refetch } = usePolicy("service") // privacy, service 중 하나로 선택
  const [htmlContent, setHtmlContent] = useState("")

  useEffect(() => {
    refetch()
      .then((res) => {
        setHtmlContent(res.data)
      })
      .catch((error) => {
        console.log(error)
        toast.error("서버 에러입니다.")
      })
  }, [refetch])

  return (
    <div>
      <Header />
      <Container>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </Container>
    </div>
  )
}

export default Privacy

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px 0;

  div {
    font-size: 13px;
  }
`
